module.exports = __webpack_public_path__ + "ab087cf6d197f507cf13f41215747242.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/hoodie-blue.png
// module id = 1294
// module chunks = 0